import React from "react";

export default function Achievements() {
  return (
    <div>
      <h2>Achievements</h2>
    </div>
  );
}
